/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V3StackAdaptTacticAd } from '../models/V3StackAdaptTacticAd';
import { V3StackAdaptTacticCustomSegmentRule } from '../models/V3StackAdaptTacticCustomSegmentRule';
import { V3StackAdaptTacticDateRule } from '../models/V3StackAdaptTacticDateRule';
import { V3StackAdaptTacticDayTimeRule } from '../models/V3StackAdaptTacticDayTimeRule';
import { V3StackAdaptTacticLanguageRule } from '../models/V3StackAdaptTacticLanguageRule';
import { V3StackAdaptTacticWeekDayRule } from '../models/V3StackAdaptTacticWeekDayRule';
import { HttpFile } from '../http/http';

/**
* Rules for creative tactics in StackAdapt campaign
*/
export class V3StackAdaptCreativeTactic {
    /**
    * Creative tactic ID
    */
    'id'?: string;
    /**
    * Creative tactic name
    */
    'name'?: string;
    /**
    * list of ads the creative tactic is associated with
    */
    'ads'?: Array<V3StackAdaptTacticAd>;
    /**
    * Whether the creative tactic is paused
    */
    'paused'?: boolean;
    /**
    * Priority of the creative tactic
    */
    'priority'?: number;
    'dateRule'?: V3StackAdaptTacticDateRule;
    'dayTimeRule'?: V3StackAdaptTacticDayTimeRule;
    'weekdayRule'?: V3StackAdaptTacticWeekDayRule;
    'languageRule'?: V3StackAdaptTacticLanguageRule;
    'customSegmentRule'?: V3StackAdaptTacticCustomSegmentRule;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "ads",
            "baseName": "ads",
            "type": "Array<V3StackAdaptTacticAd>",
            "format": ""
        },
        {
            "name": "paused",
            "baseName": "paused",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "priority",
            "baseName": "priority",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "dateRule",
            "baseName": "dateRule",
            "type": "V3StackAdaptTacticDateRule",
            "format": ""
        },
        {
            "name": "dayTimeRule",
            "baseName": "dayTimeRule",
            "type": "V3StackAdaptTacticDayTimeRule",
            "format": ""
        },
        {
            "name": "weekdayRule",
            "baseName": "weekdayRule",
            "type": "V3StackAdaptTacticWeekDayRule",
            "format": ""
        },
        {
            "name": "languageRule",
            "baseName": "languageRule",
            "type": "V3StackAdaptTacticLanguageRule",
            "format": ""
        },
        {
            "name": "customSegmentRule",
            "baseName": "customSegmentRule",
            "type": "V3StackAdaptTacticCustomSegmentRule",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3StackAdaptCreativeTactic.attributeTypeMap;
    }

    public constructor() {
    }
}

